import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const locationBaseEndpoint = ENDPOINTS.LOCATION;

// Daily Orders API
export const locationApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["locations"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getLocations: builder.query({
        query: () => `${locationBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "locations" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addLocation: builder.mutation({
        query: (requestData) => ({
          url: `${locationBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "locations" }],
      }),
      updateLocation: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${locationBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "locations" }],
      }),
      toggleLocationStatus: builder.mutation({
        query: (id) => ({
          url: `${locationBaseEndpoint}/toggle/${id}`,
          method: METHODS.PATCH,
        }),
        invalidatesTags: () => [{ type: "locations" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetLocationsQuery,
  useAddLocationMutation,
  useUpdateLocationMutation,
  useToggleLocationStatusMutation,
} = locationApi;
